/**
 * 文本气泡组件
 */

import React from 'react';
import type { ChatMessage, Character } from '../../../types';

interface TextBubbleProps {
  message: ChatMessage;
  charA: Character;
  charB: Character;
  isFirstInGroup: boolean;
  isLastInGroup: boolean;
}

export const TextBubble: React.FC<TextBubbleProps> = React.memo(({
  message, charA, charB, isFirstInGroup, isLastInGroup,
}) => {
  const isLeft = message.senderId === charA.id;
  const char = isLeft ? charA : charB;

  return (
    <div className={`flex w-full ${isLastInGroup ? 'mb-4' : 'mb-1'} ${isLeft ? 'justify-start' : 'justify-end'}`}>
      {/* Left avatar */}
      {isLeft && (
        isLastInGroup
          ? <img src={char.avatar} className="w-10 h-10 rounded-full shadow-sm mr-2 self-end shrink-0" alt={char.name} />
          : <div className="w-10 mr-2 shrink-0" />
      )}

      <div className={`max-w-[75%] md:max-w-[70%] flex flex-col ${isLeft ? 'items-start' : 'items-end'}`}>
        {isFirstInGroup && (
          <span className="text-xs text-[#6B7280] mb-1 px-1">{char.name}</span>
        )}
        <div
          className={`px-4 py-3 text-sm md:text-base leading-relaxed text-[#2D2D2D] ${isLeft
              ? 'bg-white border border-[#E5E0D8] rounded-2xl rounded-bl-sm'
              : 'bg-[#FFE0E0] rounded-2xl rounded-br-sm'
            }`}
        >
          {message.text}
        </div>
      </div>

      {/* Right avatar */}
      {!isLeft && (
        isLastInGroup
          ? <img src={char.avatar} className="w-10 h-10 rounded-full shadow-sm ml-2 self-end shrink-0" alt={char.name} />
          : <div className="w-10 ml-2 shrink-0" />
      )}
    </div>
  );
});

TextBubble.displayName = 'TextBubble';
